var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 219,
    viewBox: "0 0 219 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94335,
    ry: 35.6534,
    transform: "matrix(0.999995 -0.00319085 -0.00317762 -0.999995 110.083 48.6595)",
    fill: "#F5D751"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94736,
    ry: 17.9601,
    transform: "matrix(0.0780307 0.996951 0.996926 -0.0783536 61.0354 102.996)",
    fill: "#F5D751"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 58.7643,
    ry: 58.8865,
    transform: "matrix(1 0 0 -1 109.705 109.742)",
    fill: "#F5D751"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 49.5299,
    ry: 49.6329,
    transform: "matrix(1 0 0 -1 109.705 109.742)",
    fill: "#F5D751"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94449,
    ry: 35.6326,
    transform: "matrix(0.847013 0.531572 0.529988 -0.848005 146.187 61.9161)",
    fill: "#F5D751"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94581,
    ry: 30.7964,
    transform: "matrix(0.623481 0.781838 0.780573 -0.625064 109.939 90.9873)",
    fill: "#F5D751"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94655,
    ry: 23.707,
    transform: "matrix(-0.454394 0.890801 0.890034 0.455894 149.319 134.902)",
    fill: "#F5D751"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94337,
    ry: 23.6141,
    transform: "matrix(-0.997488 0.0708386 0.0705464 0.997508 111.631 155.307)",
    fill: "#F5D751"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94601,
    ry: 26.7289,
    transform: "matrix(-0.58283 -0.812594 -0.811445 0.584429 63.8233 139.563)",
    fill: "#F5D751"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94729,
    ry: 24.4525,
    transform: "matrix(-0.155001 -0.987914 -0.987815 0.155631 163.544 98.7458)",
    fill: "#F5D751"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.94643,
    ry: 30.6355,
    transform: "matrix(0.486393 -0.87374 -0.872879 -0.487937 72.1795 66.4574)",
    fill: "#F5D751"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 46.172,
    ry: 46.268,
    transform: "matrix(1 0 0 -1 109.705 109.742)",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.16993,
    ry: 16.1805,
    transform: "matrix(0.589301 0.807913 0.806745 -0.590899 106.97 94.5704)",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_1220_18032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.17077,
    ry: 16.4601,
    transform: "matrix(0.0130672 0.999915 0.999914 -0.0131216 105.431 105.42)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.137 119.923C155.87 131.827 153.386 141.907 151.982 143.087C148.418 146.197 111.917 157.135 106.517 157.135C101.01 157.028 68.8283 147.377 65.1566 143.087C64.7246 142.551 63.6447 138.69 62.4568 132.899C58.3531 113.704 51.8736 74.1325 55.3294 71.9878C59.865 69.0923 98.634 60.406 111.377 60.2988C124.228 60.0843 161.809 73.7036 163.753 77.2425C165.049 79.3872 161.701 101.8 158.137 119.923Z",
    fill: "url(#paint0_linear_1220_18032)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.513 60.2988C123.904 60.1915 165.157 76.2773 163.753 77.2424C162.457 78.2076 113.321 90.0038 104.142 90.0038C94.9626 90.0038 49.2821 75.0977 55.3296 71.9878C57.1655 71.0226 97.1224 60.406 110.513 60.2988Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.518 157.135C101.118 156.385 102.63 95.0441 104.142 92.4704C105.654 89.8967 159.649 78.9583 161.917 79.4945C164.077 80.0307 153.926 139.977 151.982 143.087C150.038 146.197 109.001 157.35 106.518 157.135Z",
    fill: "#912790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.137 119.923C155.87 131.827 153.386 141.907 151.982 143.087C148.418 146.197 111.917 157.135 106.517 157.135C101.01 157.028 68.8283 147.376 65.1566 143.087C64.7246 142.551 63.6447 138.69 62.4568 132.899C62.7808 133.435 64.5087 141.586 69.8003 144.374C72.0681 145.553 97.1221 154.561 105.869 154.347C114.617 154.24 145.934 148.449 150.47 141.371C154.898 134.401 158.029 120.46 158.137 119.923Z",
    fill: "#2752CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.898 152.738C105.654 150.486 122.932 124.964 122.932 119.923C122.824 114.99 103.926 93.1138 104.142 92.4704C104.358 91.827 104.898 92.0414 104.898 92.0414L125.632 118.958C136.647 114.883 144.423 115.205 145.179 113.918C145.934 112.738 163.861 77.7787 163.861 77.7787L145.503 115.741C147.662 118.529 151.982 143.087 151.982 143.087C151.982 143.087 147.554 117.993 144.531 115.956C141.507 113.918 132.004 117.243 127.468 119.923C122.932 122.712 104.574 153.06 106.518 157.135C106.518 157.135 104.142 154.991 104.898 152.738Z",
    fill: "#2752CA"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.632 121.639C124.984 123.891 143.018 117.35 144.53 115.956C146.042 114.561 131.679 115.312 125.632 121.639Z",
    fill: "#BDFF6D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.297 152.202C110.297 152.202 122.285 125.178 127.684 122.926C133.084 120.567 143.559 117.564 145.611 118.315C147.663 119.065 151.658 140.942 151.01 142.872C150.362 144.803 124.12 154.025 116.021 154.99C107.922 156.063 110.297 152.202 110.297 152.202Z",
    fill: "#912790"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.789 88.6098C113.861 89.3605 163.537 77.3497 163.537 77.3497C163.537 77.3497 163.105 77.457 159.973 78.8511C156.949 80.2452 106.625 92.5776 102.09 92.1487C97.5539 91.6125 72.3918 81.532 72.3918 81.532C72.3918 81.532 89.2385 87.2157 104.789 88.6098Z",
    fill: "#D5FF92"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.141 92.4704C101.442 100.299 103.062 139.012 102.738 137.511C102.414 136.009 101.01 91.0763 97.554 90.4329L104.141 92.4704Z",
    fill: "#D5FF92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.418 91.1834C92.9105 87.859 115.481 88.3952 116.237 88.9314C116.885 89.5748 102.306 94.615 98.418 91.1834Z",
    fill: "#F9FFD6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9775 79.4946C56.7335 75.0978 89.779 90.2185 95.5025 101.05C101.118 111.881 101.874 146.733 100.794 150.701C99.8221 154.669 70.6644 146.948 66.3448 138.905C62.0251 130.862 54.6816 87.6447 55.9775 79.4946Z",
    fill: "#C68EC5"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7226 153.704C91.7226 153.704 89.0228 154.776 87.4029 154.562C85.783 154.347 76.9277 152.739 76.0638 151.773C75.1999 150.808 62.3488 82.7117 64.2927 78.4222C66.1285 74.2399 101.982 69.0924 104.142 69.7359C106.301 70.3793 110.297 72.6313 110.297 72.6313C110.297 72.6313 84.2711 80.8887 81.3553 83.3552C78.4396 85.8217 87.9429 152.095 88.0508 152.524C88.1588 153.06 91.7226 153.704 91.7226 153.704Z",
    fill: "url(#paint1_linear_1220_18032)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.632 152.631C126.28 152.202 130.708 89.5748 128.98 86.036C127.144 82.3899 101.55 73.1673 103.278 71.7732C105.006 70.3791 108.677 69.6285 109.973 69.7357C111.269 69.7357 146.69 78.1003 147.122 81.9609C147.662 85.8215 141.615 149.736 140.103 150.701C138.591 151.666 126.712 155.312 125.632 155.205C124.552 155.098 120.448 154.132 120.448 154.132C120.448 154.132 124.984 153.06 125.632 152.631Z",
    fill: "url(#paint2_linear_1220_18032)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.438 73.5963C101.55 72.524 77.5756 65.8752 77.5756 65.8752L70.5562 67.3765C70.5562 67.3765 71.5281 64.2666 72.392 63.8376C73.148 63.5159 90.5346 59.6553 93.6664 60.2988C96.7981 61.0494 113.321 72.095 113.321 72.095L105.438 73.5963Z",
    fill: "url(#paint3_linear_1220_18032)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.559 67.9127C142.911 67.9127 113.429 72.953 110.729 72.6313C108.029 72.2023 104.142 70.4865 104.142 70.4865C104.142 70.4865 127.9 61.4784 129.412 61.5857C130.923 61.8001 146.15 65.9825 146.69 66.9476C147.122 67.8055 147.23 69.3068 147.23 69.3068C147.23 69.3068 144.206 67.9127 143.559 67.9127Z",
    fill: "url(#paint4_linear_1220_18032)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.736 154.025C129.736 154.025 131.464 89.1461 133.516 87.1086C135.567 85.071 144.315 84.5348 145.611 84.7493C146.798 84.9638 140.643 148.771 139.779 150.058C138.915 151.237 129.736 154.025 129.736 154.025Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7225 153.704C91.7225 153.704 87.6189 154.669 86.539 154.454C85.3511 154.24 77.0357 86.894 77.6836 83.2478C78.3316 79.4945 106.193 73.9181 106.193 73.9181C106.193 73.9181 126.928 82.6044 128.764 84.1058C130.6 85.6071 129.304 93.4355 129.304 93.4355C129.304 93.4355 128.548 87.0012 127.036 85.4999C125.524 83.9985 113.321 77.6714 107.489 77.8859C103.926 78.1004 100.47 83.9985 95.3942 85.7143C92.1545 86.894 84.1631 83.2479 83.0832 85.1781C80.1674 90.0039 88.5908 152.417 89.2388 152.953C89.8867 153.489 91.7225 153.704 91.7225 153.704Z",
    fill: "#7A6511"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3188 71.2371C93.4505 71.1299 103.818 72.6312 103.17 73.5964C102.63 74.5615 78.7637 81.3176 76.6038 81.532C74.444 81.6393 64.4008 79.709 65.2647 77.7787C68.1805 75.7412 87.187 71.3444 90.3188 71.2371Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.382 74.5616L148.311 69.7358C148.311 69.7358 154.898 74.7761 142.587 76.3846C130.276 77.9932 110.622 76.0629 110.622 76.0629L107.382 74.5616Z",
    fill: "#7A6511"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.4678 82.3899C76.0639 83.2478 75.7399 82.6044 73.6881 82.0682C71.5283 81.6392 63.2129 78.6365 64.2928 78.4221C65.3727 78.3148 78.8717 81.532 77.4678 82.3899Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.436 85.4999C128.548 84.8565 142.155 82.39 144.639 82.1755C147.122 81.961 141.399 86.894 132.436 85.4999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2647 82.3899C65.5887 80.1379 76.0638 84.7492 76.9278 86.1433C77.7917 87.4301 81.4634 128.503 81.0314 130.755C80.4915 133.007 72.0682 132.256 71.7442 130.755C71.4202 129.146 64.9407 84.5347 65.2647 82.3899Z",
    fill: "#C68EC5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.448 154.133C120.448 154.133 123.472 152.417 124.228 151.237C124.984 150.058 129.304 93.4355 129.304 93.4355C129.304 93.4355 127.036 149.95 126.064 152.524C125.092 155.098 120.448 154.133 120.448 154.133Z",
    fill: "#2765CA"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M112.457 73.5964C112.457 73.5964 112.421 73.5964 112.349 73.5964C112.277 73.5964 112.061 73.6322 111.701 73.7037C111.557 73.7752 111.377 73.8467 111.161 73.9182C106.625 75.7412 91.5066 83.4624 88.9148 83.9986C88.2669 84.1058 86.971 83.8914 85.1351 83.4624C78.2237 81.9611 65.0487 77.457 64.0768 76.3847C62.8888 74.9906 52.4137 48.3954 65.2647 45.2854C73.2561 43.3552 84.2712 52.7921 92.6945 60.0844C97.8781 64.4812 102.09 68.1273 104.142 67.9128C104.142 67.9128 108.137 67.8056 110.621 69.5214L109.757 71.6662C110.117 71.8806 110.477 72.1308 110.837 72.4168C111.377 72.7385 111.809 73.0603 112.025 73.2747C112.313 73.4892 112.457 73.5964 112.457 73.5964Z",
    fill: "url(#paint5_linear_1220_18032)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8071 82.3898C84.2714 84.1057 81.3557 61.1566 82.2196 57.4032C83.0835 53.7571 97.7704 72.5239 106.842 72.6311C116.021 72.7384 89.671 81.9609 88.8071 82.3898Z",
    fill: "#912790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.457 72.6311L112.025 73.2746L111.917 73.3818L111.701 73.7035L111.161 73.918C106.626 75.7411 91.507 83.4622 88.9152 83.9984C88.2672 84.1057 86.9713 83.8912 85.1355 83.4622C81.8957 76.9207 74.5523 49.1459 84.5955 55.3657C87.0793 56.9743 89.8871 58.5829 92.6949 60.0842C97.8785 64.481 102.09 68.1271 104.142 67.9126C104.142 67.9126 105.438 67.3764 107.922 68.985C106.518 67.5909 107.49 68.5561 107.382 68.2344C109.434 69.414 110.945 70.5936 111.809 71.5588C112.169 71.9162 112.385 72.2737 112.457 72.6311Z",
    fill: "#CA2790"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M146.151 70.9154C143.451 73.7036 115.697 74.9905 112.349 74.0253C112.061 73.9538 111.809 73.8466 111.593 73.7036C111.593 73.7036 111.557 73.7036 111.486 73.7036C111.414 73.6321 111.306 73.5606 111.162 73.4891C110.802 73.2747 110.478 73.0244 110.19 72.7385C109.83 72.4525 109.542 72.1665 109.326 71.8806C108.138 70.4864 107.49 68.9851 107.382 68.6634C109.758 68.5562 119.585 41.4248 122.825 38.5293C125.956 35.8484 147.015 36.8135 155.438 40.8886C156.374 41.3175 157.13 41.7822 157.706 42.2827C163.321 47.4301 148.959 68.1272 146.151 70.9154Z",
    fill: "url(#paint6_linear_1220_18032)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M112.349 72.3095C112.349 72.3095 122.176 69.6286 130.492 65.5535C142.803 59.3336 148.742 46.465 153.818 45.9288C159.218 45.2854 151.118 67.3765 141.291 70.3792C132.328 73.0602 112.349 72.3095 112.349 72.3095Z",
    fill: "#912790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.151 70.9154C143.451 73.7036 115.697 74.9904 112.349 74.0253C112.061 73.9538 111.809 73.8466 111.593 73.7036C111.593 73.7036 111.557 73.7036 111.485 73.7036C111.413 73.6321 111.233 73.6678 110.945 73.8108L110.621 74.4542L110.513 74.0253L110.189 72.7384C110.189 72.6669 110.189 72.5954 110.189 72.5239C110.333 72.238 110.621 71.952 111.053 71.666C114.293 69.5213 126.712 66.9475 134.704 59.3336C145.179 49.3604 148.527 41.8537 155.438 40.8885C156.374 41.3175 157.13 41.7822 157.706 42.2827C163.321 47.4301 148.958 68.1272 146.151 70.9154Z",
    fill: "#CA2790"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.738 67.5909C102.738 67.5909 110.405 65.6606 114.941 67.5909C119.476 69.6285 118.396 72.9529 117.964 74.4542C117.424 75.9556 108.353 75.0976 108.353 75.0976C108.353 75.0976 108.893 73.3818 108.137 71.0226C107.381 68.5561 102.738 67.5909 102.738 67.5909Z",
    fill: "url(#paint7_linear_1220_18032)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.297 66.9476C113.537 66.9476 116.993 68.9852 116.885 69.1996C116.669 69.5214 110.513 70.9155 109.757 70.272C109.001 69.7358 104.142 67.2694 104.142 67.2694C104.142 67.2694 107.057 66.8404 110.297 66.9476Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M110.189 67.162C110.189 67.162 115.265 56.4382 119.477 48.288C124.012 39.3872 140.319 43.4623 139.995 50.4328C139.671 57.0816 120.233 67.3765 117.209 67.8055C114.401 68.2344 110.189 67.162 110.189 67.162Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2648 77.0281C63.6449 75.4195 58.8932 57.4034 59.7571 54.508C60.5131 51.6125 62.8889 47.7519 69.5844 52.0415C76.3879 56.4383 84.3793 81.7466 81.0315 81.7466C81.0315 81.7466 66.7766 78.7439 65.2648 77.0281Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M110.189 67.162C110.189 67.162 118.181 50.6472 120.125 50.3255C122.069 49.8966 123.58 60.1915 120.881 63.5159C118.289 66.6258 113.321 67.6982 113.321 67.6982L110.189 67.162Z",
    fill: "#CA2790"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M67.7485 46.3577C73.58 46.4649 84.3792 53.6499 82.1113 54.0789C79.7355 54.5078 78.0077 58.0467 75.1999 54.0789C72.2841 50.111 59.8651 49.8966 60.945 48.0735C60.945 48.0735 61.9169 46.1432 67.7485 46.3577Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.498 41.6392C147.339 43.784 142.155 46.1432 136.539 43.355C131.032 40.674 120.017 43.8912 120.989 42.2826C125.74 34.6687 151.658 39.4944 149.498 41.6392Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M154.79 49.4677C155.978 56.4382 145.503 68.8779 144.099 69.3069C142.695 69.6286 134.595 63.9449 139.671 58.9047C148.958 49.5749 153.602 42.2827 154.79 49.4677Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2196 57.4032C82.7595 56.6525 84.7033 56.6525 90.2109 62.4434C95.7185 68.2343 105.33 72.3094 104.142 72.6311C102.954 72.8456 83.6234 72.4166 83.1914 70.4863C82.8675 68.985 81.6796 58.2611 82.2196 57.4032Z",
    fill: "#CA2790"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7896 71.9878C55.8695 71.0226 59.2172 70.4865 59.2172 70.4865C59.2172 70.4865 57.3814 72.2023 55.8695 77.028C54.2497 81.8537 56.7334 101.157 56.7334 101.157C53.8177 79.3873 53.7097 73.0602 54.7896 71.9878Z",
    fill: "#D5FF92"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1373 71.2371C58.1373 71.2371 56.9494 74.0253 56.6255 74.347C56.3015 74.6687 54.8976 74.347 54.7896 72.8456C54.6816 71.3443 58.1373 71.2371 58.1373 71.2371Z",
    fill: "#F9FFD6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1220_18032",
    x: 103.136,
    y: 8.00623,
    width: 13.8936,
    height: 81.3065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1220_18032",
    x: 38.1299,
    y: 95.5979,
    width: 45.811,
    height: 14.7959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1220_18032",
    x: 0.940674,
    y: 0.855469,
    width: 217.529,
    height: 217.773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1220_18032",
    x: 50.1753,
    y: 50.1091,
    width: 119.06,
    height: 119.266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1220_18032",
    x: 122.229,
    y: 26.6815,
    width: 47.9155,
    height: 70.4692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1220_18032",
    x: 80.8689,
    y: 66.6765,
    width: 58.1399,
    height: 48.6215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1220_18032",
    x: 123.2,
    y: 118.955,
    width: 52.2378,
    height: 31.8955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1220_18032",
    x: 104.075,
    y: 126.751,
    width: 15.1121,
    height: 57.1113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1220_18032",
    x: 37.104,
    y: 118.861,
    width: 53.4385,
    height: 41.4044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1220_18032",
    x: 134.387,
    y: 89.4807,
    width: 58.313,
    height: 18.5302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1220_18032",
    x: 40.4214,
    y: 46.4114,
    width: 63.5164,
    height: 40.092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1220_18032",
    x: 59.5332,
    y: 59.4741,
    width: 100.344,
    height: 100.536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1220_18032",
    x: 90.8979,
    y: 81.9622,
    width: 32.144,
    height: 25.2167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_1220_18032",
    x: 85.9722,
    y: 101.23,
    width: 38.9172,
    height: 8.38135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1220_18032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1220_18032",
    x1: 68.2884,
    y1: 157.135,
    x2: 68.2884,
    y2: 60.2988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41B816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEFF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1220_18032",
    x1: 12.3487,
    y1: 154.562,
    x2: 12.3487,
    y2: 69.7359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44009E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1220_18032",
    x1: 48.31,
    y1: 155.205,
    x2: 48.31,
    y2: 69.7357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44009E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1220_18032",
    x1: 89.5627,
    y1: 73.5963,
    x2: 89.5627,
    y2: 60.1915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44009E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1220_18032",
    x1: 124.12,
    y1: 72.6312,
    x2: 124.12,
    y2: 61.5857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E82E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1220_18032",
    x1: 73.1481,
    y1: 83.9986,
    x2: 73.1481,
    y2: 45.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44009E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1220_18032",
    x1: 120.341,
    y1: 74.347,
    x2: 120.341,
    y2: 37.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44009E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1220_18032",
    x1: 107.597,
    y1: 75.3121,
    x2: 107.597,
    y2: 66.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44009E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftbox);
export default __webpack_public_path__ + "static/media/Giftbox.344ad4e518e34a9bf62e3149b2695699.svg";
export { ForwardRef as ReactComponent };